import { TFunction } from '../types/TFunction';

export type Listener = () => void;

export interface TFunctionStore {
  addTFunction: (locale: string, t: TFunction) => void;
  subscribe: (listener: Listener) => () => void;
  getSnapshot: () => Map<string, TFunction>;
}

/**
 * Create a store for t functions.
 * @returns An object containing the functions necessary to interact with the store.
 */
export const create = (): TFunctionStore => {
  let tFunctions: Map<string, TFunction> = new Map();
  const listeners: Set<Listener> = new Set();

  const emitChange = () => {
    listeners.forEach((listener) => listener());
  };

  const addTFunction = (locale: string, t: TFunction) => {
    if (tFunctions.has(locale)) {
      return;
    }

    // The tFunctions map must be recreated for React to detect the change.
    tFunctions = new Map<string, TFunction>([...tFunctions.entries(), [locale, t]]);

    emitChange();
  };

  const subscribe = (listener: Listener) => {
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  };

  const getSnapshot = () => tFunctions;

  return {
    addTFunction,
    subscribe,
    getSnapshot,
  };
};
